import { useCallback } from 'react';
import { ESessionStatKeys, TSessionStats } from './use-fetch-session-stats';

export const useIsLoadingSessionStat = (data: TSessionStats, isPublished: boolean) => {
  return useCallback(
    (statKey: ESessionStatKeys) => {
      if (!isPublished) return false;

      const statCard = data?.[statKey];

      if (!statCard) return true;

      if (statCard.value === null || statCard.loading) return true;

      return false;
    },
    [data, isPublished]
  );
};
